export enum BookForSomeoneElseBannerDataHooks {
  BANNER = 'book-for-someone-else-banner',
}
